export class AuthCredentials {
  id: string;
  username: string;
  token: string;
  mustChangePassword: boolean;

  constructor(id: string, username: string, token: string, mustChangePassword = false) {
    this.id = id;
    this.username = username;
    this.token = token;
    this.mustChangePassword = mustChangePassword;
  }
}
